import { ISuggestion } from '@models/smarty';
import { SMARTY_URL } from '@services/smarty/smarty.constants';
import ky from 'ky';

export const fetchAddressSuggestions = (querySearchParam: string): Promise<ISuggestion> =>
  ky.get(`${SMARTY_URL}&${querySearchParam}`).json<ISuggestion>();
